import { Sparkles } from "lucide-react";
import type { ModuleSpec } from "../types";

export const customerAiActionsSpec: ModuleSpec = {
  id: "customer-ai-actions",
  icon: Sparkles,
  i18n: {
    namespace: "modules",
    titleKey: "customer-ai-actions.title",
    descriptionKey: "customer-ai-actions.description",
  },
  nav: {
    path: "/customers/actions",
    group: "observe",
    order: 75,
    subgroup: "cdp",
  },
  permission: {
    action: "read",
    subject: "cdp",
  },
  meta: {
    status: "active",
    description: "Browse the 29 catalog actions the CDP Copilot can perform",
  },
};
